import { render } from "./TrainingElements.vue?vue&type=template&id=d0f6458a"
import script from "./TrainingElements.vue?vue&type=script&lang=js"
export * from "./TrainingElements.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__